import React from 'react';
import { Trans } from 'react-i18next';
import ButtonAdd from 'components/ButtonAdd';
import { ROUTE } from 'constants/route';
import { RIGHTS } from 'constants/rights';

const Actions = () => (
  <ButtonAdd
    size="small"
    to={ROUTE.USER_DETAIL.replace(':recordId', 'new')}
    right={RIGHTS.USER.ADD}
  >
    <Trans>USER.NEW</Trans>
  </ButtonAdd>
);

export default Actions;
